export const NAVIGATION_INFO = [
  {
    id: 1,
    catMessage: "最初の目印を探してみようニャ！",
    description: "きらりデッキ",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1622.0691058325642!2d139.6113513038319!3d35.59965712270186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f50001b5b311%3A0xda17c35de2ad563c!2z44Kt44Op44Oq44OH44OD44Kt!5e0!3m2!1sja!2sjp!4v1748177161332!5m2!1sja!2sjp",
    imageSrc: "/Navigation/Landmark1.png",
    questionNumber: 1,
    question: "広場には何個の円筒型の椅子があるかな？",
    answer: "8",
    answerDetail: "広場には案内用の円筒型の椅子が8個あります。",
  },
  {
    id: 2,
    catMessage: "次の目印を探してみようニャ！",
    description: "ポレポレ通り商店街",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d811.0325466247908!2d139.61167063551287!3d35.59985509817086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f582bd55f8ab%3A0x9ac49d555919cc98!2z44Od44Os44Od44Os6YCa44KK!5e0!3m2!1sja!2sjp!4v1751895923573!5m2!1sja!2sjp",
    imageSrc: "/Navigation/Landmark2.png",
    questionNumber: 1,
    question: "白枠に隠された場所にはどんな数字が入るかな？",
    answer: "634",
    answerDetail: "白枠には『634』という数字が入ります。",
  },
  {
    id: 3,
    catMessage: "次の目印を探してみようニャ！",
    description: "溝の口神社",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.0268168561706!2d139.60780227564175!3d35.60240507261278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f4208eea5e11%3A0xef99155023c7f3af!2z5rqd5Y-j56We56S-!5e0!3m2!1sja!2sjp!4v1751007951113!5m2!1sja!2sjp",
    imageSrc: "/Navigation/Landmark3.png",
    questionNumber: 1,
    question: "白枠に隠された場所にはどんなご利益が入るかな？",
    answer: "縁結び",
    answerDetail: "溝の口神社は『縁結び』のご利益で有名です。",
  },
  {
    id: 4,
    catMessage: "次の目印を探してみようニャ！",
    description: "灰吹屋薬局本部",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.971759035024!2d139.60883758335672!3d35.603763201995164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f421755f9193%3A0x36813e45b9026954!2z54Gw5ZC55bGL6Jas5bGA5pys6YOo!5e0!3m2!1sja!2sjp!4v1751008192986!5m2!1sja!2sjp",
    imageSrc: "/Navigation/Landmark4.png",
    questionNumber: 1,
    question: "白枠に隠された場所にはどんな漢字が入るかな？",
    answer: "万",
    answerDetail: "『万』は『萬屋（よろずや）』の『万』で、灰吹屋の歴史に由来しています。",
  },
  {
    id: 5,
    catMessage: "次の目印を探してみようニャ！",
    description: "",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.0132837647693!2d139.6074379833562!3d35.60273890199646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f51f675f0197%3A0x3f4f6c88cea1341a!2z5aSn55-z5qmL!5e0!3m2!1sja!2sjp!4v1752421763832!5m2!1sja!2sjp",
    imageSrc: "/Navigation/Landmark5.png",
    questionNumber: 1,
    question: "白枠に隠された場所にはどんな言葉が入るかな？",
    answer: "にかりょうよう",
    answerDetail: "『にかりょうようすい（二ヶ領用水）』は、川崎市を流れる歴史ある用水路の名前です。",
  },
  {
    id: 6,
    catMessage: "最後の目印を探してみようニャ！",
    description: "久地円筒分水",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.828554184459!2d139.60310447564206!3d35.60729547261113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f6a148286331%3A0x56b76e944f9ae7aa!2z5LmF5Zyw5YaG562S5YiG5rC0!5e0!3m2!1sja!2sjp!4v1751008688092!5m2!1sja!2sjp",
    imageSrc: "/Navigation/Landmark6.png",
    questionNumber: 1,
    question: "白枠に隠された場所にはどんな言葉が入るかな？",
    answer: "分量",
    answerDetail: "久地円筒分水では水を『分量』で正確に分ける仕組みが使われています。",
  },
  // 他の目印データ...
];